import React from 'react';
import classNameBind from 'classnames/bind';
import Message from '../../../Message';
import Spinner from '../../../Spinner';
import List from '../../../List';
import styles from './InnerList.module.css';
import { InnerListItem } from '../InnerListItem';
import { getColumns } from './getColumns';
import { SortableWrapper } from '../SortableWrapper';

const bindClasses = classNameBind.bind(styles);

const InnerList = ({
  options,
  isLoading,
  failedMessage,
  value,
  name,
  disabled,
  pagination,
  handleChange,
  onReorder,
  search,
  disabledTooltipText,
  adaptableHeight,
  customListColumns,
} = {}) => {
  const sortable = typeof onReorder === 'function';
  const ListWrapper = sortable ? SortableWrapper({
    onDragEnd: onReorder,
    id: Math.random().toString(),
  }) : React.Fragment;

  const status = (() => {
    if (isLoading) {
      return <Spinner className="medium" />;
    }
    if (failedMessage) {
      return <Message message={failedMessage} messageType="error" centerHorizontal />;
    }

    return null;
  })();

  const availableOptions = options.length > pagination.limit
    ? options.slice(pagination.offset, pagination.offset + pagination.limit)
    : options;

  const minHeight = adaptableHeight
    ? { minHeight: `${pagination.limit * 47}px` }
    : null;

  return (
    <div
      className={bindClasses('content', { empty: options.length === 0, search })}
      style={minHeight}
      data-ppuc-id="SearchableMultiselectListbox.content"
    >
      {options.length > 0 ? (
        <ListWrapper>
          <List
            className={bindClasses('List')}
            columns={(customListColumns && customListColumns(name)) || getColumns()}
          >
            {availableOptions.map((option, index) => (
              <InnerListItem
                key={option.id}
                value={value}
                name={name}
                disabled={disabled}
                handleChange={handleChange}
                option={option}
                disabledTooltipText={disabledTooltipText}
                index={index}
                draggable={sortable}
                customListColumns={customListColumns}
              />
            ))}
          </List>
        </ListWrapper>
      ) : status}
    </div>
  );
};

InnerList.defaultProps = {
  onReorder: null,
  isLoading: false,
  failedMessage: '',
  disabled: false,
  disabledTooltipText: null,
};

export { InnerList };
